import { Link } from "react-router-dom";
import Logo from '../../../../img/logo/logo_biotech.svg'

function Header() {
    return (
        <>
            <header className="App-header">
                <div className="mx-width">
                    <div>
                        <img src={Logo} alt="logo biotech service" className="logo"/>
                    </div>
                    <div>
                        <a href="#home">Home</a>
                        <a href="#about">About us</a>
                        <a href="#about">Hamilton</a>
                        <a href="#references">References</a>
                        <a href="#contact">Contact</a>
                        <Link to="/" onClick={() => {window.location.href="/"}}>🇳🇱</Link>
                    </div>
                </div>
            </header>
        </>
    );
  }
  
  export default Header;
  